import React, { useEffect, useMemo, useState , useContext } from "react";
import {
  Box, CircularProgress, IconButton, InputAdornment, TextField, Paper, Chip, Button,
  Dialog, DialogTitle, DialogContent, Typography,
  Table, TableBody, TableCell, TableHead, TableRow,
  Select, MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MyTable from "../../components/Schedule/MyTable";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import EmptyState from "../../components/Error/EmptyState";
import Grid from '@mui/material/Grid';
import { Col, Row } from 'react-bootstrap';
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parse } from 'date-fns';
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import AuthContext from "../../context/AuthContext";

export default function EmployeeLog() {
  const {v3Data} = useContext(AuthContext)
  const navigate = useNavigate();
  let { empId } = useParams();
  const [member, setMember] = useState([]);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [detailsSearch, setDatailsSearch] = useState("");
  const [overTimeSearch, setOverTimeSearch] = useState("");
  const [summarySearch, setSummarySearch] = useState("");
  const [emptyMessage, setEmptyMessage] = useState();
  const [activeTab, setActiveTab] = useState('memberlog');
  const [year, setYear] = useState(new Date());
  const selectedYear = moment(year).format('YYYY');
  const [year2, setYear2] = useState(new Date());
  const selectedYear2 = moment(year2).format('YYYY');
  const [drilldown, setDrilldown] = useState(null);
  const [swapRows, setSwapRows] = useState([]);
  const [swapErrorMessage, setSwapErrorMessage] = useState();
  const [swapBalanceRows, setSwapBalanceRows] = useState([]);
  const [overTimeData, setOverTimeData] = useState([]);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const allowedVars = v3Data;

  useEffect(() => {
    if (empId) {
      ApiService.get("/getEmployee/" + empId).then(({ data }) => {
        setMember(data?.data)
      });
    } else {
      setLoading(false);
    }
  }, [])

  const fetchLog = (periodDate, isFirstLoad = false) => {
    const params = periodDate ? { period_date: periodDate } : {};
    if (isFirstLoad) setLoading(true);
    else setSummaryLoading(true);
    ApiService.get("/getEmployeeLog/" + empId, params, "getEmployeeLog")
      .then(({ data }) => {
        setData(data);
        if (isFirstLoad) {
          setAvailablePeriods(data?.available_periods || []);
          setLoading(false);
        } else {
          setSummaryLoading(false);
        }
      })
      .catch((error) => {
        if (isFirstLoad) setLoading(false);
        else setSummaryLoading(false);
        if (error.response?.status == 400 && error.response?.data?.message) {
          setEmptyMessage(error.response.data.message);
        } else {
          toast.error(error?.response?.data?.message);
          navigate("/firehouse/members");
        }
      });
  };

  useEffect(() => {
    fetchLog(null, true);
  }, []);

  const handlePeriodChange = (period) => {
    const resolved = period === '' ? null : period;
    setSelectedPeriod(resolved);
    fetchLog(resolved, false);
  };

  useEffect(() => {
    if (empId) {
      ApiService.get("/getEmployeeLogOvertime/" + empId).then(({ data }) => {
        setOverTimeData(data.overTime || [])
      });
    } else {
      setLoading(false);
    }
  }, [])

  const columns = [
    {
      field: "Shift_Date", headerName: "Date", flex: 1, minWidth: 95,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    { field: "AbsentDesc", headerName: "Type", flex: 1, minWidth: 70 },
    { field: "shift_name", headerName: "Shift", flex: 1, minWidth: 65,
      valueGetter: (params) => params.row.shift?.Shift ? params.row.shift?.Shift : params.row.custom?.Shift,
     },
    {
      field: "age",
      headerName: "Hours",
      flex: 1,
      minWidth: 40,
      maxWidth: 55,
      valueGetter: (params) => params.row.custom?.Hours ?? params.row.shift?.Shift_Hours,
    },
    {
      field: "StatusName",
      headerName: "Status",
      renderCell: (params) => {
        return <Chip style={{ width: "100px", fontSize: '12px', backgroundColor: 'rgba(255, 165, 0, 0.26)', border: '1px solid rgba(255, 165, 0, 0.28)' }} label={params.row.StatusName} />;
      },
      flex: 1,
      minWidth: 90,
    },
  ];

  const columnsOverTime = [
    {
      field: "Shift_Date",
      headerName: "Shift Date",
      flex: 1,
      maxWidth: 90,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    {
      field: "ResponseName",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Chip style={{ width: "90%", fontSize: '12px' }} label={params.row.ResponseName} />
        );
      },
    },
    {
      field: "ShiftDescription", headerName: "Shift", flex: 1, minWidth: 100,
      renderCell: (params) => {
        return (
          <Chip style={{ width: "90%", fontSize: '12px', backgroundColor: 'rgba(52, 152, 219, 0.16)', border: '1px solid rgba(52, 152, 219, 0.2)' }} label={params.row.ShiftDescription} />
        );
      },
    },
    { field: "Hours", headerName: "Hours", flex: 1, minWidth: 60, maxWidth: 60 },
    {
      field: "totalHours",
      headerName: "Total Hours",
      flex: 1,
      minWidth: 100,
      maxWidth: 100
    },
    { field: "fullName", headerName: "User", flex: 1, minWidth: 220 },
    ...(allowedVars?.V3_STORE_OVERTIME_REASON ||
      allowedVars?.V3_STORE_OVERTIME_REASON === "true"
        ? [
            {
              field: "reason",
              headerName: "Reason",
              flex: 1,
              minWidth: 200,
              renderCell: (params) => (
                <div
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {params?.row?.reason}
                </div>
              ),
            },
          ]
        : []),
    { field: "FormattedLogTime", headerName: "Time Stamp", flex: 1, minWidth: 140 },
  ];

  const columnsSummary = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 90 },
    {
      field: "date", headerName: "Start Date", flex: 1, minWidth: 100,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    ...(allowedVars?.V3_HIDE_SOLD_AND_ACCRUED_IN_SUMMARY ? [] : [{
      field: "accrued", headerName: "Accrued", flex: 1, minWidth: 70,
      renderCell: (params) => {
        const list = params.row.accrued_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Accrued', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    }]),
    ...(allowedVars?.V3_HIDE_SOLD_AND_ACCRUED_IN_SUMMARY ? [] : [{ field: "sold", headerName: "Sold", flex: 1, minWidth: 50 }]),
    {
      field: "used", headerName: "Used", flex: 1, minWidth: 50,
      renderCell: (params) => {
        const list = params.row.used_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Used', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "planned", headerName: "Planned", flex: 1, minWidth: 70,
      renderCell: (params) => {
        const list = params.row.planned_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Planned', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "available",
      headerName: "Available",
      flex: 1,
      minWidth: 80,
    },
  ];

  const columnsSummaryCompressed = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 90 },
    {
      field: "date", headerName: "Start Date", flex: 1, minWidth: 100,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    {
      field: "accrued", headerName: "Accrued", flex: 1, minWidth: 70,
      renderCell: (params) => {
        const list = params.row.accrued_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Accrued', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    },
    //{ field: "sold", headerName: "Sold", flex: 1, minWidth: 50 },
    {
      field: "used", headerName: "Used", flex: 1, minWidth: 50,
      renderCell: (params) => {
        const list = params.row.used_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Used', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "planned", headerName: "Planned", flex: 1, minWidth: 70,
      renderCell: (params) => {
        const list = params.row.planned_list;
        if (!list?.length) return params.value ?? 0;
        return (
          <span style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            onClick={() => setDrilldown({ type: 'Planned', name: params.row.name, list })}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "available",
      headerName: "Available",
      flex: 1,
      minWidth: 80,
    },
  ];

  const columns2 = [
    {
      field: 'Shift_Date',
      headerName: 'Shift Date',
      width: 160,
      renderCell: (params) => {
        return moment(params.value).format('MM/DD/YYYY');
      },
    },
    {
      field: 'Shift_Code',
      headerName: 'Shift',
      width: 300,
      renderCell: (params) => {
        const status = params.value;
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '60%',
            color: '#2E3238',
            backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
          label={status === 2 ? 'Day' : status === 91 ? `${params?.row?.TempShiftType}` : 'Night'}
        />;
      },
    },
    { field: 'Request_By', headerName: 'Requested by', width: 220 },
    { field: 'Request_To', headerName: 'Requested to', width: 220 },
    {
      field: 'Cancel_swap',
      headerName: 'Status',
      width: 240,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            sx={{
              backgroundColor:
                (params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' :
                  (params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#ff0000',
              color: (params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? '#000000'
                : (params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#ffffff'
                  : '#ffffff',
              marginLeft: '10px',
              padding: '4px 20px',
              boxShadow: 'none',
              borderRadius: '30px',
              width: '140px',
              '&:hover': {
                backgroundColor:
                  (params.row.requestedCancelSwap && params.row.requestedCancelSwapStatus == 'Requested') ? 'orange' :
                    (params.row.requestedCancelSwapStatus == 'DECLINED' && params.row.requestedCancelSwap) ? '#000000' : '#E62719',
                boxShadow: 'none',
              },
            }}
          >	{params.row.requestedCancelSwap ? params.row.requestedCancelSwapStatus : 'Request Swap'}
          </Button>
        );
      },
    },

  ];

  useEffect(() => {
    setLoading(true)
    ApiService.get("/ot-swap-report/" + empId, {
      'year': selectedYear
    })
      .then(({ data }) => {
        setLoading(false);
        const objectData = data?.data || {};
        const arrayData = Object.values(objectData);
        const updatedRows = arrayData.map((item, index) => ({
          ...item,
          id: index + 1
        }));

        setSwapRows(updatedRows);
      })
      .catch((error) => {
        setLoading(false);
        setSwapRows([]);
        if (error.response.status == 400 && error.response?.data?.message) {
          setSwapErrorMessage(error.response.data.message);
        } else {
          toast.error(error?.response?.data?.message)
          // enqueueSnackbar("Error", { variant: "error" });
          navigate("/firehouse/members");
        }
      });
  }, [year, selectedYear]);

  const columns3 = [
    {
      field: 'start_date',
      headerName: 'Date',
      width: 240,
      renderCell: (params) => {
        return `(${params.row.start_date}  to  ${params.row.end_date})`
      },
    },
    { field: 'name', headerName: 'Swaps with', width: 300 },
    {
      field: 'sent_count',
      headerName: 'Swaps Request',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#ff0000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'received_count',
      headerName: 'Swaps Done',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#008000', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'swap_balance',
      headerName: 'Balances',
      width: 210,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#555555', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
  ];

  useEffect(() => {
    setLoading(true)
    ApiService.get("/ot-swap-balance-report/" + empId,
      {
        'year': selectedYear2
      }
    )
      .then((data) => {
        setLoading(false);
        const responseData = data?.data?.data;
        const updatedRows = [];
        Object.entries(responseData).forEach(([fromId, fromData]) => {
          const fromName = fromData.full_name;
          const swapWith = fromData.swap_with;
          const start_date = moment(fromData.start_date).format('MM/DD/YYYY');
          const end_date = moment(fromData.end_date).format('MM/DD/YYYY');

          Object.entries(swapWith).forEach(([toId, toData], index) => {
            updatedRows.push({
              id: index + 1,
              name: toData.full_name,
              start_date: start_date,
              end_date: end_date,
              sent_count: toData.sent_count,
              received_count: toData.received_count,
              swap_balance: toData.swap_balance,
            });
          });
        });
        setSwapBalanceRows(updatedRows)
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message)
        // enqueueSnackbar("Error", { variant: "error" });
      });
  }, [year2, selectedYear2]);

  const detailsRes = useMemo(() => {
    return data?.details.filter((x) => {
      return (
        x.AbsentDesc.toLowerCase().includes(detailsSearch.toLowerCase()) ||
        x.Overtime_List.toLowerCase().includes(detailsSearch.toLowerCase())
      );
    });
  }, [detailsSearch, data]);

  const overtimeRes = useMemo(() => {
    return data?.overTime.filter((x) => {
      return (
        x.ResponseName.toLowerCase().includes(overTimeSearch.toLowerCase()) ||
        x.Shift_Type.toLowerCase().includes(overTimeSearch.toLowerCase()) ||
        x.fullName.toLowerCase().includes(overTimeSearch.toLowerCase())
      );
    });
  }, [overTimeSearch, data]);

  const summaryRes = useMemo(() => {
    return data?.summary.filter((x) => {
      return (
        x.name.toLowerCase().includes(summarySearch.toLowerCase()) ||
        x.start.toString().includes(summarySearch.toLowerCase())
      );
    });
  }, [summarySearch, data]);


  if (loading) {
    return (
      <Box className="w-100 d-flex justify-content-center align-items-center" style={{ height: 665 }}>
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <>
        <Box className='m-3'>
          <Link to="/firehouse/members" style={{ color: "#555555" }}>
            <ArrowBackIosIcon />
          </Link>
          <span className="fw-500">Member ({member.fullName})</span>
        </Box>
        <Paper className="m-3">
          <Box className='px-3' style={{ paddingTop: activeTab == 'memberlog' ? '35px' : '26px' }}>
            <Row>
              <Col md={8} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '160px' }} className={activeTab == 'memberlog' ? 'tab-active' : 'tab-white'}
                  onClick={() => setActiveTab('memberlog')}>
                  Member Log
                </div>
                <div style={{ width: '160px' }} className={activeTab == 'swaps-list' ? 'tab-active mx-2' : 'tab-white mx-2'}
                  onClick={() => setActiveTab('swaps-list')}>
                  Swap Details
                </div>
                <div style={{ width: '160px' }} className={activeTab == 'swaps-balances' ? 'tab-active' : 'tab-white'}
                  onClick={() => setActiveTab('swaps-balances')}>
                  Swap Balances
                </div>
              </Col>
              {(activeTab == 'swaps-list') &&
                <Col md={4} sm={10} xs={10}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={3}>
                      <Grid item md={6} sm={10} xs={10}>
                        <DatePicker
                          label="Select Year"
                          views={['year']}
                          value={year}
                          onChange={(newValue) => setYear(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </Grid>
                    </Grid>
                  </LocalizationProvider>
                </Col>
              }
              {(activeTab == 'swaps-balances') &&
                <Col md={4} sm={10} xs={10}>
                  <Row>
                    <Col md={6} sm={10} xs={10}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Select Year"
                          views={['year']}
                          value={year2}
                          onChange={(newValue) => setYear2(newValue)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </Col>
                  </Row>
                </Col>
              }
            </Row>
          </Box>

          {activeTab == 'memberlog' &&
            <div>
              <>
                <Box className="p-4 my-3">
                  <div>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                      <p style={{ fontSize: '22px', fontWeight: '600', marginBottom: 0 }}>
                        Time Off &amp; Accruals ({selectedPeriod ? moment(selectedPeriod).format('MMM D, YYYY') : 'current period'})
                      </p>
                      {availablePeriods.length > 0 && (
                        <Select
                          size="small"
                          value={selectedPeriod ?? ''}
                          onChange={(e) => handlePeriodChange(e.target.value)}
                          displayEmpty
                          sx={{
                            fontFamily: 'karla, sans-serif',
                            fontSize: 13,
                            minWidth: 165,
                            '& .MuiSelect-select': { py: 0.75 },
                          }}
                        >
                          <MenuItem value="" sx={{ fontFamily: 'karla, sans-serif', fontSize: 13, color: 'text.secondary' }}>
                            Current Period
                          </MenuItem>
                          {availablePeriods.map((period) => {
                            const isFuture = period > new Date().toISOString().slice(0, 10);
                            return (
                              <MenuItem key={period} value={period} sx={{ fontFamily: 'karla, sans-serif', fontSize: 13 }}>
                                {moment(period).format('MMM D, YYYY')}
                                {isFuture && (
                                  <Chip
                                    label="upcoming"
                                    size="small"
                                    sx={{ ml: 1, height: 16, fontSize: 10, backgroundColor: 'rgba(191,29,45,0.1)', color: '#BF1D2D' }}
                                  />
                                )}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    </Box>

                    <Box sx={{ flexGrow: 1 }} >
                      <Grid container >
                        {detailsRes && detailsRes?.length > 0 &&
                          <Grid item xs={12} sm={12} md={12}>
                            <CollapseComponent
                                rows={detailsRes}
                                name={'Details'}
                                columns={columns}
                                checkboxSelection={false}
                                hideFooter={true}
                                open={true}
                              />
                          </Grid>
                        }

                        {summaryLoading ? (
                          <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                              <CircularProgress size={28} />
                            </Box>
                          </Grid>
                        ) : summaryRes && summaryRes?.length > 0 && (
                          <Grid item xs={12} sm={12} md={12}>
                            <CollapseComponent
                                rows={summaryRes}
                                columns={(allowedVars && Object.keys(allowedVars).includes('V3_REMOVE_SELL_ACCRUAL_FEATURE')) ? columnsSummaryCompressed : columnsSummary}
                                checkboxSelection={false}
                                name={'Summary'}
                                hideFooter={true}
                                open={true}
                              />
                          </Grid>
                        )}

                      </Grid>
                    </Box>

                  </div>
                </Box>
              </>

              {emptyMessage && (
                <>
                  <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 300, width: "100%" }}>
                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                    <span className='mt-4' style={{ color: '#555555' }}>
                      {emptyMessage}
                    </span>
                  </div>
                </>
              )}

              <Box className='px-4'>
                <p style={{ fontSize: '22px', fontWeight: '600' }}>
                  Overtime Lists
                </p>
                {overTimeData && Object.entries(overTimeData).length > 0 ? (
                  <div>
                    {Object.entries(overTimeData).map(([key, value]) => (
                      <CollapseComponent
                        key={key}
                        name={key}
                        rows={value}
                        columns={columnsOverTime}
                        checkboxSelection={false}
                        hideFooter={true}
                        open={true}
                      // useSearch={(e) => setOverTimeSearch(e)}
                      />
                    ))}
                  </div>
                ) : (
                  <div
                    className='d-flex flex-column align-items-center justify-content-center'
                    style={{ height: 300, width: '100%' }}
                  >
                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                    <span className='mt-4' style={{ color: '#555555' }}>
                      No Overtime Lists
                    </span>
                  </div>
                )}
              </Box>
            </div>
          }

          {loading &&
            <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
              <CircularProgress />
            </Box>
          }

          {activeTab == 'swaps-list' &&
            <div>
              {swapRows?.length > 0 ? (
                <Box className='p-3'>
                  <MyTable
                    rows={swapRows}
                    columns={columns2}
                    checkboxSelection={false}
                    useTopFilter={false}
                  />
                </Box>
              ) : (
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565, width: "100%" }}>
                  <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                  <span className='mt-4' style={{ color: '#555555' }}>
                    No Swap Details Found
                  </span>
                </div>
              )}
            </div>
          }

          {activeTab == 'swaps-balances' &&
            <div>
              {swapBalanceRows?.length > 0 ? (
                <Box className='p-3'>
                  <MyTable
                    rows={swapBalanceRows}
                    columns={columns3}
                    checkboxSelection={false}
                    useTopFilter={false}
                  />
                </Box>
              ) : (
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565, width: "100%" }}>
                  <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                  <span className='mt-4' style={{ color: '#555555' }}>
                    No Balances Found
                  </span>
                </div>
              )}
            </div>
          }
        </Paper>

        {/* Drilldown Dialog */}
        <Dialog open={!!drilldown} onClose={() => setDrilldown(null)} fullWidth maxWidth="xs"
          PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden' } }}>
          <DialogTitle sx={{
            backgroundColor: '#BF1D2D',
            color: '#fff',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            py: 1.5,
            px: 2.5,
          }}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                {drilldown?.type} — {drilldown?.name}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.85 }}>
                {drilldown?.list?.length} {drilldown?.list?.length === 1 ? 'entry' : 'entries'}
                {' · '}
                {drilldown?.list?.reduce((s, i) => s + Number(i.hours), 0)} total hrs
              </Typography>
            </Box>
            <IconButton size="small" sx={{ color: '#fff', mt: -0.25 }} onClick={() => setDrilldown(null)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0, maxHeight: 340, overflow: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: 'grey.50', position: 'sticky', top: 0, zIndex: 1 }}>
                  <TableCell sx={{ fontWeight: 600, pl: 2.5, py: 1.25, borderBottom: '2px solid', borderColor: 'grey.200' }}>
                    Date
                  </TableCell>
                  {drilldown?.list?.[0]?.shift !== undefined && (
                    <TableCell sx={{ fontWeight: 600, py: 1.25, borderBottom: '2px solid', borderColor: 'grey.200' }}>
                      Shift
                    </TableCell>
                  )}
                  <TableCell align="right" sx={{ fontWeight: 600, pr: 2.5, py: 1.25, borderBottom: '2px solid', borderColor: 'grey.200' }}>
                    Hours
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {drilldown?.list?.map((item, i) => (
                  <TableRow key={i} hover>
                    <TableCell sx={{ pl: 2.5, py: 1 }}>{moment(item.date).format('MM/DD/YYYY')}</TableCell>
                    {item.shift !== undefined && (
                      <TableCell sx={{ py: 1 }}>
                        <Chip
                          label={item.shift}
                          size="small"
                          sx={{
                            fontSize: '11px',
                            height: 22,
                            backgroundColor: item.shift === 'Day' ? 'rgba(52,152,219,0.15)' : 'rgba(255,165,0,0.22)',
                            border: `1px solid ${item.shift === 'Day' ? 'rgba(52,152,219,0.3)' : 'rgba(255,165,0,0.35)'}`,
                            color: item.shift === 'Day' ? '#1565c0' : '#e65100',
                            fontWeight: 500,
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell align="right" sx={{ pr: 2.5, py: 1 }}>{item.hours}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <Box sx={{ backgroundColor: 'grey.50', borderTop: '2px solid', borderColor: 'grey.200', px: 2.5, py: 1.25, display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>Total</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {drilldown?.list?.reduce((s, i) => s + Number(i.hours), 0)} hrs
            </Typography>
          </Box>
        </Dialog>
      </>
    );
  }
}
